<template>
  <el-container id="root_container" style="padding: 0px;margin: 0px; overflow: hidden;">

    <el-header class="headerManu"  >
      <div style="height: 60px;background-color: transparent;float: left; margin-left: 20px; display: flex;flex-direction: row;justify-content: start;"   @click="goHome()">
        <img  :src="logo"  style="float: left;width: 50px;height: 50px;margin-top: 5px;"/>
        <div style="background-color: transparent; color: white; height: 60px; display: flex;flex-direction: column;justify-content: start; padding-left: 10px;">
          <div class="BSD_TITLE">Global Change Risk Map Platform</div>
          <div class="BSD_SUBTITLE">of Population and Economic Systems</div>
        </div>
      </div>
    </el-header>


    <el-main id="router_view" style="background-color: #F5F7FA;width: 100%;height: 500px;text-align: center;">

      <div id="form_container" style="width: 70%;background-color: white;margin-left: 15%;margin-top: 10px;border-radius: 3px;display: flex;flex-direction: row;justify-content: center;">

        <div style="margin-top: 5%;">
          <el-col style="width: 400px; padding: 20px 40px; border: solid 1px lightgrey;border-radius: 3px; height: auto;box-shadow: 0px 0px 5px lightgrey; ">

            <el-row style="background-color: transparent;font-family: 'Microsoft YaHei'">
              <p style="height: 30px;line-height: 30px;font-size: 20px; font-weight: bold;">Reset Password</p>
            </el-row>

            <el-row v-if="passwordResetStep==1">
              <el-row style="background-color: transparent;">
                <p style="width: 100%;text-align: left; font-family: 'Courier New'">Enter your e-mail address below to reset your password.</p>
              </el-row>

              <el-row style="margin-top: 20px;">
                <el-input placeholder="Register Mailbox" v-model="mailBox"></el-input>
              </el-row>

              <el-row style="margin-top: 25px;margin-bottom: 40px;">
                <el-button type="primary" style="width: 100%; font-size: 17px;" :disabled="mailBox==undefined || mailBox.length==0" @click="GetVerificationCode">Get Verification Code</el-button>
              </el-row>
            </el-row>

            <el-row v-if="passwordResetStep==2">
              <el-row style="background-color: transparent;">
                <p style="width: 100%;text-align: left; font-family: 'Courier New'">Please enter the verification code received by your email address</p>
              </el-row>

              <el-row style="margin-top: 20px;">
                <el-input placeholder="Verification Code" v-model="mailBoxCode"></el-input>
              </el-row>

              <el-row style="margin-top: 25px;margin-bottom: 40px;">
                <el-button type="primary" style="width: 100%; font-size: 17px;" :disabled="mailBoxCode==undefined || mailBoxCode.length==0" @click="submitPasswordResetRequest">Submit</el-button>
              </el-row>
            </el-row>


            <el-row v-if="passwordResetStep==3">

              <el-row style="background-color: transparent;">
                <p style="width: 100%;text-align: left; font-family: 'Courier New'">
                  Please log in to your mailbox and reset your password through the link in the email
                </p>
              </el-row>

              <el-row style="margin-top: 25px;margin-bottom: 40px;">
                <el-button type="primary" style="width: 100%; font-size: 17px;" @click="goHome">Done</el-button>
              </el-row>
            </el-row>




            <el-divider></el-divider>

            <el-row style="text-align: center;padding: 15px 0px;font-size: 14px;">
              <a href="/#/BNUMap/Login" style="color:deepskyblue;font-weight: bold;">
                REMBER MY ACCOUNT
              </a>
            </el-row>

          </el-col>
        </div>

      </div>
    </el-main>

  </el-container>
</template>

<script>
import {Notify} from "vant";

let bsd_logo =  require( '../../../src/assets/icons/earth.png');

import { api_bnu_sendPasswordRequestLink ,api_bnu_getMailCode} from "@/api";
export default {
  name: "FindPassword",
  data(){
    return {
      logo:bsd_logo,
      mailBox:undefined,
      mailBoxCode:undefined,
      passwordResetStep:1,

    }
  },
  methods:{

    goHome(){
      this.$router.push({path:'/BNUMap/cc'})
    },
    /**
     * send password reset mail
     * */
    GetVerificationCode(){
      let _this = this;
      api_bnu_getMailCode({mail:this.mailBox}).then(res=>{
        let resData = res.data;
        console.log("resData.code = ",resData.code);
        if(resData.code==200000){
          console.log("200000");
          _this.passwordResetStep = 2;
        }
        else if(resData.code==200001){
          console.log("200001");
          _this.passwordResetStep = 2;
          alert(resData.msg);
        }
        else {
          alert(resData.msg);
        }
      })
    },
    submitPasswordResetRequest(){
      console.log("submitPasswordResetRequest::");
      let _this = this;
      api_bnu_sendPasswordRequestLink({
        mail:this.mailBox,
        verifyCode:this.mailBoxCode
      }).then(res=>{
        let resData = res.data;
        console.log("submitPasswordResetRequest && resData = ",resData);
        if(resData.code==200000){
          _this.passwordResetStep = 3;
        }else {
          alert(resData.msg);
        }
      })
    }

  },

  mounted() {
    document.getElementById("router_view").style.height = document.body.clientHeight - 60 +"px";
    document.getElementById("form_container").style.height = document.body.clientHeight - 60 - 20 +"px";
  }
}
</script>




<style scoped lang="scss">
@import "BSDMap";
.headerManu{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/view/BSD/FindPassword.vue